import { Dispatch, Action } from "redux";
import { AxiosError, AxiosResponse } from "axios";
import { notification } from "antd";

import {
  downloadBlobFile,
  mapDataRows,
  showErrorNotification,
} from "../../../../utils";
import { ApiService, ApiServiceFormData } from "../../../../services";
import { GET_ORDERS, GET_CERTIFIED_ORDERS, IS_LOADING } from "./types";

const setLoading = (loading: boolean) => ({
  type: IS_LOADING,
  payload: loading,
});

export const getOrders = () => async (dispatch: Dispatch<Action>) => {
  ApiService.get("/offer-response")
    .then((res: AxiosResponse) => {
      const { status, data } = res;
      if (status !== 200) {
        showErrorNotification("Učitavanje narudžbi nije uspjelo");
        return;
      }

      const orders = mapDataRows(data.rows);

      dispatch({
        type: GET_ORDERS,
        payload: orders,
      });
    })
    .catch((err: AxiosError) => {
      showErrorNotification("Učitavanje narudžbi nije uspjelo", err);
    });
};

export const getCertifiedOrders = () => async (dispatch: Dispatch<Action>) => {
  ApiService.get("/offer-response/certified")
    .then((res: AxiosResponse) => {
      const { status, data } = res;
      if (status !== 200) {
        showErrorNotification("Učitavanje ovjerenih narudžbi nije uspjelo");
        return;
      }

      const certifiedOrders = mapDataRows(data.rows);

      dispatch({
        type: GET_CERTIFIED_ORDERS,
        payload: certifiedOrders,
      });
    })
    .catch((err: AxiosError) => {
      showErrorNotification("Učitavanje ovjerenih narudžbi nije uspjelo", err);
    });
};

export const addCertifiedOrder =
  (id: string, file: File, handleClose: () => void) =>
  async (dispatch: Dispatch<Action>) => {
    dispatch(setLoading(true));

    const formData = new FormData();
    formData.append("file", file);

    ApiServiceFormData.put(`/offer-response/${id}/certified-order`, formData)
      .then((res: AxiosResponse) => {
        const { status } = res;

        if (status !== 200) {
          showErrorNotification("Slanje ovjerene narudžbe nije uspjelo");
          return;
        }

        notification.success({
          message: "Ovjerena narudžba je poslana.",
        });

        handleClose();
        getCertifiedOrders()(dispatch);
      })
      .catch((err: AxiosError) => {
        showErrorNotification("Slanje ovjerene narudžbe nije uspjelo", err);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

export const downloadOrder = (id: string) => async () => {
  ApiService.get(`/offer-response/${id}/order-download`, {
    responseType: "blob",
  })
    .then((res: AxiosResponse) => {
      const blob = new Blob([res.data]);
      downloadBlobFile(blob, `order-${id}.pdf`);
    })
    .catch((err: AxiosError) => {
      showErrorNotification("Preuzimanje narudžbe nije uspjelo", err);
    });
};

export const downloadCertifiedOrder =
  (id: string, filename: string) => async () => {
    ApiService.get(`/offer-response/${id}/certified-order-download`, {
      responseType: "blob",
    })
      .then((res: AxiosResponse) => {
        const blob = new Blob([res.data]);
        downloadBlobFile(blob, filename);
      })
      .catch((err: AxiosError) => {
        showErrorNotification(
          "Preuzimanje ovjerene narudžbe nije uspjelo",
          err
        );
      });
  };
